import TextBlockEditor from "./TextBlockEditor";

export default function InfoBlockEditor({ block, type = "دانستنی", onChange }) {

    const textBlock = {
        id: `${block.id}_text`,
        config: {
            text: block.config.text
        }
    };

    return (
        <div className="space-y-4">

            <input
                className="w-full border rounded-lg p-3"
                placeholder="عنوان"
                value={block.config.title}
                onChange={(e) =>
                    onChange({
                        config: {
                            ...block.config,
                            title: e.target.value
                        }
                    })
                }
            />

            <TextBlockEditor
                block={textBlock}
                onChange={(patch) =>
                    onChange({
                        config: {
                            ...block.config,
                            text: patch.config.text
                        }
                    })
                }
            />

        </div>
    );
}